import React from 'react';
import PropTypes from 'prop-types';

export default function HuntsIcon(props) {
  return (
    <svg width={props.width} height={props.width} viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2 3.604V12.789C2.00001 13.4475 2.16257 14.0957 2.47326 14.6763C2.78395 15.2568 3.23315 15.7517 3.781 16.117L9 19.597L14.219 16.117C14.7667 15.7518 15.2158 15.2571 15.5265 14.6767C15.8372 14.0964 15.9998 13.4483 16 12.79V3.604L9 2.05L2 3.604ZM0.783 1.826L9 0L17.217 1.826C17.4391 1.87536 17.6377 1.99897 17.78 2.1764C17.9224 2.35384 18 2.57452 18 2.802V12.789C17.9999 13.7767 17.756 14.7492 17.2899 15.62C16.8238 16.4908 16.1499 17.2331 15.328 17.781L9 22L2.672 17.781C1.85027 17.2332 1.17646 16.4911 0.710348 15.6205C0.244236 14.7498 0.000236356 13.7776 0 12.79V2.802C3.90378e-05 2.57452 0.0776379 2.35384 0.21999 2.1764C0.362341 1.99897 0.560937 1.87536 0.783 1.826ZM9 12.5L6.061 14.045L6.622 10.773L4.245 8.455L7.531 7.977L9 5L10.47 7.977L13.755 8.455L11.378 10.773L11.938 14.045L9 12.5Z" fill={props.color} />
    </svg>
  );
}

HuntsIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number
};

HuntsIcon.defaultProps = {
  color: '#fff',
  width: 20
};
